import { TableEmptyState } from '@practium/ui';
import type { Plan, Hierarchy } from '../../../types';
import styles from '../SystemTable.module.css';

interface PlansTableProps {
	plans: Plan[];
	hierarchies?: Hierarchy[];
	onRowClick?: (id: string) => void;
}

const resolveHierarchyName = (hierarchy: string | Hierarchy, hierarchies?: Hierarchy[]): string => {
	if (typeof hierarchy === 'object') return hierarchy.name;
	return hierarchies?.find(h => h._id === hierarchy)?.name || hierarchy || '—';
};

export const PlansTable = ({ plans, hierarchies, onRowClick }: PlansTableProps) => {
	if (plans.length === 0) {
		return (
			<TableEmptyState
				title="Nenhum plano encontrado"
				subtitle="Adicione um plano para começar"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome</th>
						<th>Hierarquia</th>
						<th>Assinantes</th>
						<th>Link de Pagamento</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{plans.map(item => (
						<tr
							key={item._id}
							onClick={() => onRowClick?.(item._id)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{item.name}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>
									{resolveHierarchyName(item.hierarchy, hierarchies)}
								</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.subscriberCount}</span>
							</td>
							<td>
								<a
									href={item.paymentLink}
									target="_blank"
									rel="noopener noreferrer"
									className={styles.link}
									onClick={e => e.stopPropagation()}
								>
									{item.paymentLink || '—'}
								</a>
							</td>
							<td>
								<span
									className={`${styles.statusBadge} ${
										item.status === 'active' ? styles.statusActive : styles.statusInactive
									}`}
								>
									{item.status === 'active' ? 'Ativo' : 'Inativo'}
								</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
